import { Center, Location, Term, TermPageType } from '@/types/models'
import { isCenterEatingDisorders } from '../center'
import { UNITED_STATES_NAMES } from '../location/constants'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isNonEmptyString } from '@/utils/checks'
export const rewriteCenterBreadcrumb = ({
  center,
  item
}: {
  center: Center
  item: Location | Term
}) => {
  if (
    isCenterEatingDisorders(center) &&
    isNonEmptyString(item?.title) &&
    UNITED_STATES_NAMES.has(item?.title)
  ) {
    return {
      slug: `${TermPageType.what_we_treat}/eating-disorders`,
      title: PrimaryFocus.EATING_DISORDERS,
      type: item.type
    }
  }
  if (isCenterEatingDisorders(center)) {
    return {
      slug: `${item.slug}/eating-disorders`,
      title: item.title,
      type: item.type
    }
  }
  return { slug: item?.slug, title: item?.title, type: item?.type }
}
